<template>
  <div class="row-red-nav">
    <div class="main-width">
      <ul id="red-nav-navbar" class="list-basic-settings">
        <li><a href="home.html" class="row-red-nav-a">首页</a></li>
        <li><a href="purchase.html" class="row-red-nav-a">招采信息</a></li>
        <!-- <li><a href="logistics.html" class="row-red-nav-a">物流招标</a></li>
        <li><a href="logisticses.html" class="row-red-nav-a">工程招标</a></li>
        <li><a href="service.html" class="row-red-nav-a">服务招标</a></li> -->
        <!--<li><a href="deal.html" class="row-red-nav-a">询比价</a></li>-->
        <!-- <li><a href="deal.html" class="row-red-nav-a">竞买竞卖</a></li>
        <li><a href="notice.html" class="row-red-nav-a">公告信息</a></li> -->
        <!-- <li><a href="loop.html" class="row-red-nav-a">循环物资</a></li> -->
        <li><a target="_blank" href="contact.html" class="row-red-nav-a">联系我们</a></li>
        <!-- 郎酒要求屏蔽 -->
        <!-- <li><a :href="apiLinks.selfHome" target="_blank" class="row-red-nav-a">返回官网</a></li> -->
      </ul>
    </div>
  </div>
</template>
<script>
  import {apiLinks} from '../api/links'
  export default{
    name: 'grednav',
    props: {
      type: ''
    },
    data () {
      return {
        apiLinks: apiLinks
      }
    }
  }
</script>
<style lang="less">
  @import '../assets/base.less';
  /*row-red-nav*/
  .row-red-nav {
    height: 40px;
    background-color: @primary;
  }

  #red-nav-navbar > li {
    width: 14%;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }

  #red-nav-navbar > li > a {
    display: block;
    width: 100%;
    height: 100%;
  }

  #red-nav-navbar > li:hover {
    background-color: @primarydark;
    cursor: pointer;
  }

  .row-red-nav-a, .row-red-nav-a:hover, .row-red-nav-a:visited {
    font-size: 16px;
    color: #ffffff;
    text-decoration: none;
  }

  .li-active {
    background-color: @primary;
  }
</style>



// WEBPACK FOOTER //
// G-rednav.vue?24393eca